module.exports = __webpack_public_path__ + "static/media/custom.0bb3c2e4.png";